import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=b754ebc4&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=b754ebc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b754ebc4",
  null
  
)

export default component.exports